export async function createOrder(client, { accountId }) {
  return await client.order.create(
    {
      data: {
        type: 'Order',
        attributes: {
          source: 'web',
        },
        relationships: {
          account: {
            data: {
              id: accountId,
              type: 'Account',
            },
          },
        },
      },
    },
    ['delivery_address', 'account']
  );
}

/**
 * @param client
 * @param orderId
 * @param attributes
 * @param {{deliveryWindowId?: String, deliveryAddressId?: String}?} relationships
 * @return {Promise<*>}
 */
export async function updateOrder(client, { orderId, accountId, attributes = {}, relationships = {} }) {
  const relationshipApiParam: any = {};
  const { deliveryWindowId, deliveryAddressId } = relationships as any;

  if (deliveryWindowId) {
    relationshipApiParam.delivery_window = {
      data: {
        id: deliveryWindowId,
        type: 'DeliveryWindow',
      },
    };
  }
  if (deliveryAddressId) {
    relationshipApiParam.delivery_address = {
      data: {
        id: deliveryAddressId,
        type: 'DeliveryAddress',
      },
    };
  }

  relationshipApiParam.account = {
    data: {
      type: 'Account',
      id: accountId,
    },
  };

  return await client.order.patch(
    orderId,
    {
      data: {
        type: 'Order',
        id: orderId,
        relationships: relationshipApiParam,
        attributes: attributes,
      },
    },
    ['delivery_address', 'delivery_window']
  );
}

export function fetchOrder(client, { orderId }) {
  return client.order.get(orderId, ['order_item', 'delivery_address', 'delivery_window']);
}

export async function processOrder(client, { orderId }) {
  return await client.order.process(orderId);
}

export async function createOrderItem(client, { price, orderId, fulfillmentId, productId }) {
  return await client.orderItem.create(
    {
      data: {
        type: 'OrderItem',
        attributes: {
          quantity: 1,
          price: price,
        },
        relationships: {
          order: {
            data: {
              id: orderId,
              type: 'Order',
            },
          },
          prescription_fulfillment: {
            data: {
              id: fulfillmentId,
              type: 'PrescriptionFulfillment',
            },
          },
          product: {
            data: {
              id: productId,
              type: 'Product',
            },
          },
        },
      },
    },
    ['order']
  );
}

export async function getOrderDeliveryWindows(client, { orderId }) {
  return await client.order.availableDeliveryWindows(orderId);
}

/**
 * Gets the Order History for the current user
 *
 * @param client
 * @returns {*}
 */
export function getCurrentUserOrderHistory(client) {
  return client.order.listPlaced([
    'order_item',
    'delivery_window',
    'order_item.prescription_fulfillment',
    'order_item.prescription_fulfillment.prescription',
  ]);
}

export async function getOrderHistory(client) {
  return await client.bffOrders();
}

export async function bffGetOrderIdFromShortCode(client, shortCode: string) {
  return await client.bffGetOrderIdFromShortCode(shortCode);
}

export async function getOrderDetails(client, orderId) {
  return await client.bffGetOrderDetail(orderId);
}
